<template>
	<section class="other_page_banner brecv banner_nxt_sec_touch">
		<div class="container">
			<div class="row">
				<div class="col-sm-7 order-2 order-md-1">
					<div class="ban_lt">
						<h5>
							{{ $t('new_ui.business_receive_page.section_banner.title.one') }}
						</h5>
						<h2>
							{{
								$t('new_ui.business_receive_page.section_banner.main_title.one')
							}}
						</h2>
						<h6>
							{{
								$t('new_ui.business_receive_page.section_banner.sub_title.one')
							}}
						</h6>
						<p>
							{{
								$t('new_ui.business_receive_page.section_banner.paragraph.one')
							}}
						</p>

						<div
							class="ban_lt_btn d-flex justify-content-start align-items-center p-top"
						></div>
					</div>
				</div>
				<div class="col-sm-5 order-1 order-md-2">
					<div class="ban_rt">
						<img :src="img.image1" alt="Logo" />
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="advantage_sec brcv_adv_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12">
					<div class="advantage_inn">
						<span>{{
							$t('new_ui.business_receive_page.advantage_sec.label')
						}}</span>
						<h4>
							{{ $t('new_ui.business_receive_page.advantage_sec.title.one') }}
							<span>{{
								$t('new_ui.business_receive_page.advantage_sec.title.two')
							}}</span>
						</h4>
						<p>
							{{ $t('new_ui.business_receive_page.advantage_sec.paragraph') }}
						</p>
					</div>
					<div class="advntage_btm">
						<div class="row d-none d-md-flex">
							<div class="col-sm-12 col-xxl-4 col-xl-4 col-lg-4 col-md-6">
								<div class="advntage_btm_inn">
									<div class="advntage_btm_inn_up">
										<img :src="img.image2" alt="Logo" />
									</div>
									<div class="advntage_btm_inn_dwn">
										<span>{{
											$t(
												'new_ui.business_receive_page.advntage_btm_inn_dwn_1st.label',
											)
										}}</span>
										<h6>
											{{
												$t(
													'new_ui.business_receive_page.advntage_btm_inn_dwn_1st.title.one',
												)
											}}<br />
											{{
												$t(
													'new_ui.business_receive_page.advntage_btm_inn_dwn_1st.title.two',
												)
											}}
										</h6>
										<p>
											{{
												$t(
													'new_ui.business_receive_page.advntage_btm_inn_dwn_1st.paragraph',
												)
											}}
										</p>
										<div class="starting_to_btn pay_world">
											<a href="/auth/register">{{
												$t(
													'new_ui.business_receive_page.advntage_btm_inn_dwn_1st.cta_buttons',
												)
											}}</a>
										</div>
									</div>
								</div>
							</div>
							<div class="col-sm-12 col-xxl-4 col-xl-4 col-lg-4 col-md-6">
								<div class="advntage_btm_inn">
									<div class="advntage_btm_inn_up">
										<img :src="img.image3" alt="Logo" />
									</div>
									<div class="advntage_btm_inn_dwn">
										<span>{{
											$t(
												'new_ui.business_receive_page.advntage_btm_inn_dwn_2nd.label',
											)
										}}</span>
										<h6>
											{{
												$t(
													'new_ui.business_receive_page.advntage_btm_inn_dwn_2nd.title.one',
												)
											}}<br />{{
												$t(
													'new_ui.business_receive_page.advntage_btm_inn_dwn_2nd.title.two',
												)
											}}
										</h6>
										<p>
											{{
												$t(
													'new_ui.business_receive_page.advntage_btm_inn_dwn_2nd.paragraph',
												)
											}}
										</p>
										<div class="starting_to_btn pay_world">
											<a href="/auth/register">{{
												$t(
													'new_ui.business_receive_page.advntage_btm_inn_dwn_2nd.cta_buttons',
												)
											}}</a>
										</div>
									</div>
								</div>
							</div>
							<div class="col-sm-12 col-xxl-4 col-xl-4 col-lg-4 col-md-6">
								<div class="advntage_btm_inn">
									<div class="advntage_btm_inn_up">
										<img :src="img.image4" alt="Logo" />
									</div>
									<div class="advntage_btm_inn_dwn">
										<span>{{
											$t(
												'new_ui.business_receive_page.advntage_btm_inn_dwn_3rd.label',
											)
										}}</span>
										<h6>
											{{
												$t(
													'new_ui.business_receive_page.advntage_btm_inn_dwn_3rd.title.one',
												)
											}}
											<br />{{
												$t(
													'new_ui.business_receive_page.advntage_btm_inn_dwn_3rd.title.two',
												)
											}}
										</h6>
										<p>
											{{
												$t(
													'new_ui.business_receive_page.advntage_btm_inn_dwn_3rd.paragraph',
												)
											}}
										</p>
										<div class="starting_to_btn pay_world">
											<a href="/auth/register">{{
												$t(
													'new_ui.business_receive_page.advntage_btm_inn_dwn_3rd.cta_buttons',
												)
											}}</a>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="row d-block d-md-none">
							<div class="col-sm-12 border_dash">
								<div class="row">
									<div class="enjoy_slider">
										<swiper
											:slides-per-view="1"
											:space-between="30"
											:loop="true"
											:pagination="{
												el: '.swiper-pagination-3',
												clickable: true,
											}"
											:autoplay="{ delay: 2000, disableOnInteraction: false }"
											:breakpoints="{
												0: { slidesPerView: 1 },
												600: { slidesPerView: 1.5 },
												768: { slidesPerView: 2 },
												1000: { slidesPerView: 3 },
												1200: { slidesPerView: 4.5 },
											}"
										>
											<swiper-slide>
												<div
													class="col-sm-12 col-xxl-6 col-xl-6 col-lg-6 col-md-6"
												>
													<div class="advntage_btm_inn">
														<div class="advntage_btm_inn_up">
															<img :src="img.image2" alt="Logo" />
														</div>
														<div class="advntage_btm_inn_dwn">
															<span>{{
																$t(
																	'new_ui.business_receive_page.advntage_btm_inn_dwn_1st.label',
																)
															}}</span>
															<h6>
																{{
																	$t(
																		'new_ui.business_receive_page.advntage_btm_inn_dwn_1st.title.one',
																	)
																}}<br />
																{{
																	$t(
																		'new_ui.business_receive_page.advntage_btm_inn_dwn_1st.title.two',
																	)
																}}
															</h6>
															<p>
																{{
																	$t(
																		'new_ui.business_receive_page.advntage_btm_inn_dwn_1st.paragraph',
																	)
																}}
															</p>
															<div class="starting_to_btn pay_world">
																<a href="/auth/register">{{
																	$t(
																		'new_ui.business_receive_page.advntage_btm_inn_dwn_1st.cta_buttons',
																	)
																}}</a>
															</div>
														</div>
													</div>
												</div>
											</swiper-slide>
											<swiper-slide>
												<div
													class="col-sm-12 col-xxl-6 col-xl-6 col-lg-6 col-md-6"
												>
													<div class="advntage_btm_inn">
														<div class="advntage_btm_inn_up">
															<img :src="img.image3" alt="Logo" />
														</div>
														<div class="advntage_btm_inn_dwn">
															<span>{{
																$t(
																	'new_ui.business_receive_page.advntage_btm_inn_dwn_2nd.label',
																)
															}}</span>
															<h6>
																{{
																	$t(
																		'new_ui.business_receive_page.advntage_btm_inn_dwn_2nd.title.one',
																	)
																}}<br />{{
																	$t(
																		'new_ui.business_receive_page.advntage_btm_inn_dwn_2nd.title.two',
																	)
																}}
															</h6>
															<p>
																{{
																	$t(
																		'new_ui.business_receive_page.advntage_btm_inn_dwn_2nd.paragraph',
																	)
																}}
															</p>
															<div class="starting_to_btn pay_world">
																<a href="/auth/register">{{
																	$t(
																		'new_ui.business_receive_page.advntage_btm_inn_dwn_2nd.cta_buttons',
																	)
																}}</a>
															</div>
														</div>
													</div>
												</div>
											</swiper-slide>
											<swiper-slide>
												<div class="advntage_btm_inn">
													<div class="advntage_btm_inn_up">
														<img :src="img.image4" alt="Logo" />
													</div>
													<div class="advntage_btm_inn_dwn">
														<span>{{
															$t(
																'new_ui.business_receive_page.advntage_btm_inn_dwn_3rd.label',
															)
														}}</span>
														<h6>
															{{
																$t(
																	'new_ui.business_receive_page.advntage_btm_inn_dwn_3rd.title.one',
																)
															}}
															<br />{{
																$t(
																	'new_ui.business_receive_page.advntage_btm_inn_dwn_3rd.title.two',
																)
															}}
														</h6>
														<p>
															{{
																$t(
																	'new_ui.business_receive_page.advntage_btm_inn_dwn_3rd.paragraph',
																)
															}}
														</p>
														<div class="starting_to_btn pay_world">
															<a href="/auth/register">{{
																$t(
																	'new_ui.business_receive_page.advntage_btm_inn_dwn_3rd.cta_buttons',
																)
															}}</a>
														</div>
													</div>
												</div>
											</swiper-slide>
										</swiper>
										<!-- Move pagination outside swiper -->
										<div class="swiper-pagination-3"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="solution_sec brecv_solu_mid">
		<div class="container">
			<div class="row">
				<div class="col-sm-12">
					<div class="solution_inn">
						<span>{{
							$t('new_ui.business_receive_page.solution_sec.label')
						}}</span>
						<h4>
							{{ $t('new_ui.business_receive_page.solution_sec.title.one') }}
							<span>{{
								$t('new_ui.business_receive_page.solution_sec.title.two')
							}}</span>
						</h4>
						<p>
							{{ $t('new_ui.business_receive_page.solution_sec.paragraph') }}
						</p>

						<div class="brcv_solution_dsk">
							<div class="enjoy_shopping_sec">
								<div class="enjoy_shopping_box_sec">
									<div class="enjoy_shopping_inn">
										<div class="enjoy_shopping_box">
											<img :src="img.image29" alt="" />
											<div class="offer_round">1</div>
										</div>
										<div class="enjoy_shopping_dwn">
											<h6>
												{{
													$t(
														'new_ui.business_receive_page.brcv_solution_dsk_1st.label',
													)
												}}
											</h6>
											<p>
												{{
													$t(
														'new_ui.business_receive_page.brcv_solution_dsk_1st.paragraph',
													)
												}}
											</p>
										</div>
									</div>

									<div class="enjoy_shopping_inn shoping_mid">
										<div class="enjoy_shopping_box">
											<img :src="img.image5" alt="" />
											<div class="offer_round offer_round2">2</div>
										</div>
										<div class="enjoy_shopping_dwn">
											<h6>
												{{
													$t(
														'new_ui.business_receive_page.brcv_solution_dsk_2nd.label',
													)
												}}
											</h6>
											<p>
												{{
													$t(
														'new_ui.business_receive_page.brcv_solution_dsk_2nd.paragraph',
													)
												}}
											</p>
										</div>
									</div>

									<div class="enjoy_shopping_inn">
										<div class="enjoy_shopping_box">
											<img :src="img.image6" alt="" />
											<div class="offer_round">3</div>
										</div>
										<div class="enjoy_shopping_dwn">
											<h6>
												{{
													$t(
														'new_ui.business_receive_page.brcv_solution_dsk_3rd.label',
													)
												}}
											</h6>
											<p>
												{{
													$t(
														'new_ui.business_receive_page.brcv_solution_dsk_3rd.paragraph',
													)
												}}
											</p>
										</div>
									</div>
								</div>
							</div>

							<div class="enjoy_shopping_sec">
								<div class="enjoy_shopping_box_sec">
									<div class="enjoy_shopping_inn">
										<div class="enjoy_shopping_box">
											<img :src="img.image7" alt="" />
											<div class="offer_round">6</div>
										</div>
										<div class="enjoy_shopping_dwn">
											<h6>
												{{
													$t(
														'new_ui.business_receive_page.brcv_solution_dsk_6th.label',
													)
												}}
											</h6>
											<p>
												{{
													$t(
														'new_ui.business_receive_page.brcv_solution_dsk_6th.paragraph',
													)
												}}
											</p>
										</div>
									</div>

									<div class="enjoy_shopping_inn payment_arw">
										<div class="enjoy_shopping_box">
											<img :src="img.image8" alt="" />
											<div class="offer_round offer_round2">5</div>
										</div>
										<div class="enjoy_shopping_dwn">
											<h6>
												{{
													$t(
														'new_ui.business_receive_page.brcv_solution_dsk_5th.label',
													)
												}}
											</h6>
											<p>
												{{
													$t(
														'new_ui.business_receive_page.brcv_solution_dsk_5th.paragraph',
													)
												}}
											</p>
										</div>
									</div>

									<div class="enjoy_shopping_inn dwn_crv">
										<div class="enjoy_shopping_box">
											<img :src="img.image9" alt="" />
											<div class="offer_round">4</div>
										</div>
										<div class="enjoy_shopping_dwn">
											<h6>
												{{
													$t(
														'new_ui.business_receive_page.brcv_solution_dsk_4th.label',
													)
												}}
											</h6>
											<p>
												{{
													$t(
														'new_ui.business_receive_page.brcv_solution_dsk_4th.paragraph',
													)
												}}
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="brcv_solution_mbl">
							<div class="enjoy_slider">
								<swiper
									:slides-per-view="1"
									:space-between="30"
									:loop="true"
									:pagination="{
										el: '.swiper-pagination-2',
										clickable: true,
									}"
									:autoplay="{ delay: 2000, disableOnInteraction: false }"
									:breakpoints="{
										0: { slidesPerView: 1 },
										600: { slidesPerView: 1.5 },
										768: { slidesPerView: 2 },
										1000: { slidesPerView: 3 },
										1200: { slidesPerView: 4.5 },
									}"
								>
									<swiper-slide>
										<div class="enjoy_shopping_inn">
											<div class="enjoy_shopping_box">
												<img :src="img.image29" alt="" />
												<div class="offer_round">1</div>
											</div>
											<div class="enjoy_shopping_dwn">
												<h6>
													{{
														$t(
															'new_ui.business_receive_page.brcv_solution_dsk_1st.label',
														)
													}}
												</h6>
												<p>
													{{
														$t(
															'new_ui.business_receive_page.brcv_solution_dsk_1st.paragraph',
														)
													}}
												</p>
											</div>
										</div>
									</swiper-slide>
									<swiper-slide>
										<div class="enjoy_shopping_inn">
											<div class="enjoy_shopping_box">
												<img :src="img.image5" alt="" />
												<div class="offer_round offer_round2">2</div>
											</div>
											<div class="enjoy_shopping_dwn">
												<h6>
													{{
														$t(
															'new_ui.business_receive_page.brcv_solution_dsk_2nd.label',
														)
													}}
												</h6>
												<p>
													{{
														$t(
															'new_ui.business_receive_page.brcv_solution_dsk_2nd.paragraph',
														)
													}}
												</p>
											</div>
										</div>
									</swiper-slide>
									<swiper-slide>
										<div class="enjoy_shopping_inn">
											<div class="enjoy_shopping_box">
												<img :src="img.image6" alt="" />
												<div class="offer_round">3</div>
											</div>
											<div class="enjoy_shopping_dwn">
												<h6>
													{{
														$t(
															'new_ui.business_receive_page.brcv_solution_dsk_3rd.label',
														)
													}}
												</h6>
												<p>
													{{
														$t(
															'new_ui.business_receive_page.brcv_solution_dsk_3rd.paragraph',
														)
													}}
												</p>
											</div>
										</div>
									</swiper-slide>
									<swiper-slide>
										<div class="enjoy_shopping_inn">
											<div class="enjoy_shopping_box">
												<img :src="img.image9" alt="" />
												<div class="offer_round">4</div>
											</div>
											<div class="enjoy_shopping_dwn">
												<h6>
													{{
														$t(
															'new_ui.business_receive_page.brcv_solution_dsk_4th.label',
														)
													}}
												</h6>
												<p>
													{{
														$t(
															'new_ui.business_receive_page.brcv_solution_dsk_4th.paragraph',
														)
													}}
												</p>
											</div>
										</div>
									</swiper-slide>
									<swiper-slide>
										<div class="enjoy_shopping_inn">
											<div class="enjoy_shopping_box">
												<img :src="img.image8" alt="" />
												<div class="offer_round offer_round2">5</div>
											</div>
											<div class="enjoy_shopping_dwn">
												<h6>
													{{
														$t(
															'new_ui.business_receive_page.brcv_solution_dsk_5th.label',
														)
													}}
												</h6>
												<p>
													{{
														$t(
															'new_ui.business_receive_page.brcv_solution_dsk_5th.paragraph',
														)
													}}
												</p>
											</div>
										</div>
									</swiper-slide>
									<swiper-slide>
										<div class="enjoy_shopping_inn">
											<div class="enjoy_shopping_box">
												<img :src="img.image7" alt="" />
												<div class="offer_round">6</div>
											</div>
											<div class="enjoy_shopping_dwn">
												<h6>
													{{
														$t(
															'new_ui.business_receive_page.brcv_solution_dsk_6th.label',
														)
													}}
												</h6>
												<p>
													{{
														$t(
															'new_ui.business_receive_page.brcv_solution_dsk_6th.paragraph',
														)
													}}
												</p>
											</div>
										</div>
									</swiper-slide>
								</swiper>
								<!-- Move pagination outside swiper -->
								<div class="swiper-pagination-2"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="newsletter_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 col-xxl-5 col-xl-5 col-lg-5 col-md-12">
					<div class="newsletter_lt">
						<span>{{
							$t('new_ui.business_receive_page.section_newsletter.label')
						}}</span>
						<div class="newsletter_txt">
							<h4>
								<span>{{
									$t(
										'new_ui.business_receive_page.section_newsletter.title.one',
									)
								}}</span>
								{{
									$t(
										'new_ui.business_receive_page.section_newsletter.title.two',
									)
								}}
							</h4>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-xxl-7 col-xl-7 col-lg-7 col-md-12">
					<div class="newsletter_rt">
						<p>
							{{
								$t(
									'new_ui.business_receive_page.section_newsletter.description.one',
								)
							}}
						</p>
						<form>
							<div class="news_mail">
								<div class="news_mail_lt">
									<input
										type="email"
										:placeholder="
											$t(
												'new_ui.business_receive_page.section_newsletter.form.placeholder',
											)
										"
									/>
								</div>
								<div class="news_mail_rt">
									<button type="submit" value="submit">
										{{
											$t(
												'new_ui.business_receive_page.section_newsletter.form.button',
											)
										}}
									</button>
								</div>
							</div>
						</form>
						<p class="mt-3">
							{{
								$t(
									'new_ui.business_receive_page.section_newsletter.description.two',
								)
							}}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import brcvban from '@/assets/images/sub/brecv_ban.png';
import adv1 from '@/assets/images/sub/adv1.png';
import adv2 from '@/assets/images/sub/adv2.png';
import adv3 from '@/assets/images/sub/adv3.png';
import choose from '@/assets/images/sub/Choose.png';
import invoice from '@/assets/images/sub/Invoice & Estimate.png';
import paywith from '@/assets/images/sub/Pay With Us.png';
import handmobile from '@/assets/images/sub/handmobile.png';
import payment from '@/assets/images/sub/Accept Direct Payment.png';
import direct from '@/assets/images/sub/direct1.png';
import SwiperCore, { Autoplay, Pagination } from 'swiper';
SwiperCore.use([Autoplay, Pagination]);

export default {
	data: () => {
		return {
			img: {
				image1: brcvban,
				image2: adv1,
				image3: adv2,
				image4: adv3,
				image29: choose,
				image5: invoice,
				image6: handmobile,
				image7: paywith,
				image8: payment,
				image9: direct,
			},
		};
	},
};
</script>
